import React from "react";

import Checkbox from "@components/atoms/Input/Checkbox";

interface IProps {
  label: string;
  name: string;
  id?: string;
  value?: string;
  checked: boolean;
  onChange?: () => void;
}

function FilterItem({ label, name, id, value, checked, onChange }: IProps) {
  return (
    <li className="w-fit" key={label}>
      <Checkbox
        checked={checked}
        id={id ?? label}
        label={label}
        name={name}
        onChange={onChange}
        value={value ?? label}
      />
    </li>
  );
}

export default FilterItem;
